import type { SupportedRepubName } from './types';

export type LogoConfig = {
  alt: string;
  mobileSrc?: (resourcesUrl: string) => string;
  src: (resourcesUrl: string) => string;
  style?: React.CSSProperties;
} | null;

/**
 * Logo configurations for each republic
 */
export const LOGO_CONFIGS = {
  WS: {
    alt: 'WhoScored',
    src: (resourcesUrl: string) => `${resourcesUrl}/assets/img/ws-logo-white.png`,
    style: { maxWidth: '180px', maxHeight: '75px' },
  },
  US: {
    alt: 'OddsChecker',
    src: (resourcesUrl: string) => `${resourcesUrl}/assets/img/oc-pro-logo.svg`,
    style: {},
  },
  OC: {
    alt: 'OddsChecker',
    src: (resourcesUrl: string) => `${resourcesUrl}/assets/img/oc-pro-logo.svg`,
    style: {},
  },
  GZ: {
    alt: 'Gazetta',
    src: (resourcesUrl: string) => `${resourcesUrl}/assets/img/gazzetta-logo.svg`,
    mobileSrc: (resourcesUrl: string) => `${resourcesUrl}/assets/img/gazzetta-logo-mobile.svg`,
    style: {},
  },
} satisfies Record<SupportedRepubName, LogoConfig>;

/**
 * Logo URL configurations for each republic
 */
export const LOGO_URL_CONFIGS = {
  WS: 'https://www.whoscored.com',
} satisfies Partial<Record<SupportedRepubName, string>>;
